"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphStylesApp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ParagraphStyles_styles_1 = require("./ParagraphStyles.styles");
const ParagraphStyles_1 = require("./ParagraphStyles");
function ParagraphStylesApp({ labels, folders, styles, onStyleClick, }) {
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const [isFiltered, setIsFiltered] = (0, react_1.useState)(false);
    const orphanStyles = (0, react_1.useMemo)(() => {
        const stylesInFolder = folders.flatMap((folder) => folder.styles.map((style) => style.id));
        const state = Object.keys(styles).filter((styleId) => !stylesInFolder.includes(Number(styleId)));
        return state.map((styleId) => (Object.assign(Object.assign({}, styles[Number(styleId)]), { id: Number(styleId) })));
    }, [folders, styles]);
    const [filteredContent, setFilteredContent] = (0, react_1.useState)({
        folders,
        styles: orphanStyles,
    });
    (0, react_1.useEffect)(() => {
        if (!searchValue) {
            setFilteredContent({
                folders,
                styles: orphanStyles,
            });
            setIsFiltered(false);
            return;
        }
        const filterStyle = (searchValue) => (style) => style.name.toLowerCase().includes(searchValue.toLowerCase());
        const filteredFolders = folders.map((folder) => (Object.assign(Object.assign({}, folder), { styles: folder.styles.filter(filterStyle(searchValue)) })));
        const filteredStyles = orphanStyles.filter(filterStyle(searchValue));
        setIsFiltered(true);
        setFilteredContent({
            folders: filteredFolders,
            styles: filteredStyles,
        });
    }, [searchValue, folders, orphanStyles]);
    return ((0, jsx_runtime_1.jsxs)(ParagraphStyles_styles_1.StyledWrapper, { children: [(0, jsx_runtime_1.jsx)(ParagraphStyles_styles_1.StyledSearchWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.SearchBox, { id: 'search-paragraph-style', placeholder: labels.searchPlaceholder, onChange: (value) => setSearchValue(value), debounceTime: 150 }) }), filteredContent.folders.map((folder) => folder.styles.length > 0 ? ((0, jsx_runtime_1.jsx)(ParagraphStyles_1.FolderContainer, Object.assign({}, folder, { visible: isFiltered, children: (0, jsx_runtime_1.jsx)(ParagraphStyles_styles_1.StyledStylesWrapper, { children: folder.styles.map((style) => ((0, jsx_runtime_1.jsx)(ParagraphStyles_1.ParagraphStyleCard, { style: style, onStyleClick: onStyleClick }, `paragraph-style-${style.id}`))) }) }), `folder-${folder.id}`)) : null), filteredContent.styles.map((style) => ((0, jsx_runtime_1.jsx)(ParagraphStyles_styles_1.StyledOrphanStyleWrapper, { children: (0, jsx_runtime_1.jsx)(ParagraphStyles_1.ParagraphStyleCard, { style: style, onStyleClick: onStyleClick }) }, `paragraph-style-${style.id}`)))] }));
}
exports.ParagraphStylesApp = ParagraphStylesApp;
//# sourceMappingURL=App.js.map